import { useWindowEvent } from "./useWindowEvent"

export function useKeydown(key: string, callback: () => void) {
  useWindowEvent(
    "keydown",
    (event) => {
      if (event.key === key) {
        callback()
      }
    },
    { capture: true },
  )
}
